// Routing for the Tools > Reports menu actions (see MenuBar's
// turbineReportItems): which action was clicked and which parameter dialog a
// custom report's model needs (C++ report_menu_item_cls::check_and_perform).

export interface ParsedReportAction {
  /** stability | controller | compare | custom | event */
  kind: string;
  configName: string;
  /** Report ini name (custom) or event model name (event). */
  name: string;
}

/** Parse a `tools.report.{kind}.{config}` / `tools.report.{kind}.{config}:{name}`
 *  action. Returns null for non-report actions. */
export function parseReportAction(action: string): ParsedReportAction | null {
  const prefix = "tools.report.";
  if (!action.startsWith(prefix)) return null;
  const rest = action.slice(prefix.length);
  const dot = rest.indexOf(".");
  if (dot < 0) return null;
  const kind = rest.slice(0, dot);
  const target = rest.slice(dot + 1);
  const colon = target.indexOf(":");
  if (colon < 0) return { kind, configName: target, name: "" };
  return { kind, configName: target.slice(0, colon), name: target.slice(colon + 1) };
}

export interface ReportDialogChoice {
  dialog: "reportDate" | "reportMonth" | "reportYear" | "reportTime";
  /** Show the turbine-state combo (DATE_STATE reports). */
  withState: boolean;
}

/** Which parameter dialog a custom report's `report_model_name` needs; null
 *  when it has none (generation runs directly). */
export function dialogForReportModel(modelName: string): ReportDialogChoice | null {
  switch (modelName) {
    case "":
      return null;
    case "DATE":
      return { dialog: "reportDate", withState: false };
    case "DATE_STATE":
      return { dialog: "reportDate", withState: true };
    case "MONTH":
      return { dialog: "reportMonth", withState: false };
    case "YEAR":
      return { dialog: "reportYear", withState: false };
    default:
      // Any other model name is an event model: the time-window dialog.
      return { dialog: "reportTime", withState: false };
  }
}
